import { useLocalStorageState } from 'ahooks';
import { Alert, Typography } from 'antd';
import { FC } from 'react';

import { useDetectAdBlock } from './useDetectAdBlock';

const AdBlockAlert: FC = () => {
  const adBlockDetected = useDetectAdBlock();
  const [value, setValue] = useLocalStorageState('adblock.banner', {
    defaultValue: true,
  });

  if (!adBlockDetected || !value) {
    return null;
  }

  return (
    <Alert
      banner
      closable
      message={
        <>
          <Typography.Text strong>Ad-blocker detected:</Typography.Text> Please
          disable your ad blocker for this domain or you may experience errors!
        </>
      }
      onClose={() => setValue(false)}
      showIcon
      type="warning"
    />
  );
};

AdBlockAlert.displayName = 'AdBlockAlert';

export default AdBlockAlert;
